import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik } from "formik";
import { Grid, Typography, Card } from "@mui/material";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import api from "../../../components/services/api";
import withReactContent from "sweetalert2-react-content";
import Autocomplete from "@mui/material/Autocomplete";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { makeStyles } from "@mui/styles";
const useStyles = makeStyles({
  customOutline: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "red",
    },
  },
});
export default function EditFactory() {
  const history = useHistory();
  const EmpId = localStorage.getItem("EmpId");
  const [factory_data, setFactory_data] = useState([]);
  let { id } = useParams();
  const data_params = { id: id };
  const classes = useStyles();
  const [company, setCompany] = useState("");
  const [branch, setBranch] = useState("");
  const [companyData, setCompanyData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [companyDataFilter, setCompanyDataFilter] = useState([]);
  const [branchDataFilter, setBranchDataFilter] = useState([]);
  const getDataCompanyList = async () => {
    try {
      const res = await api.get("api/master/company");
      setCompanyData(res.data.data.filter((e) => e.Status === true));
      setCompanyDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };
  const getDataBranchList = async () => {
    try {
      const res = await api.get("api/master/branch");
      // console.log(data);
      setBranchData(res.data.data.filter((e) => e.Status === true));
      setBranchDataFilter(res.data.data.filter((e) => e.Status === true));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getDataCompanyList();
    getDataBranchList();
  }, []);
  const getData = async () => {
    try {
      const data = await api
        .post("api/factory/detail", data_params)
        .then((response) => {
          if (response.data.length !== 0) {
            [].concat(response.data).map((res) => {
              //   console.log(res);
              setFactory_data(res);
              setCompany(res?.CompanyId)
              setBranch(res?.BranchId)
            });
          } else {
            const MySwal = withReactContent(Swal);

            MySwal.fire({
              icon: "success",
              didOpen: () => {
                MySwal.clickConfirm();
              },
            }).then(() => {
              return MySwal.fire(
                "ผิดพลาด!",
                "ไม่พบรหัสอ้างอิงดังกล่าว !",
                "error"
              ).then((result) => {
                if (result.isConfirmed) {
                  history.push("/CustomerSupport/Factory");
                }
              });
            });
            // console.log("Nodata" + response);
          }
          //   console.log(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  };
  //api call
  useEffect(() => {
    // console.log(id);
    // GET request using axios inside useEffect React hook
    getData();

    // empty dependency array means this effect will only run once (like componentDidMount in classes)
  }, []);
  return (
    <div>
      <Card variant="outlined" style={{ padding: "20px", margin: "25px" }}>
        <h6 style={{ marginTop: "10px" }} className="textcolorgreen">
          โรงงาน
        </h6>

        <Grid container alignItems="center" spacing={1}>
          <Grid item xs>
            <Typography
              className="textcolordarkblue"
              variant="h5"
              component="h1"
            >
              Factory
            </Typography>
          </Grid>
          <Grid item sx={{ display: "flex", flexDirection: "row" }}>
            <Typography className="textcolorBule">Customer Support</Typography>
            <Typography>
              <span>&nbsp;</span> / Factory
            </Typography>
          </Grid>
        </Grid>

        <Formik
          enableReinitialize
          initialValues={{
            factory_name: factory_data.FactoryName,
            FactoryCode: factory_data.FactoryCode,
            FactoryMAC5Code: factory_data.FactoryMAC5Code,
            factory_phone: factory_data.FactoryMobile,
            factory_fax: factory_data.FactoryFax,
            factory_address: factory_data.FactoryAddress,
            status: factory_data.Status
              ? factory_data.Status === true
                ? 1
                : 0
              : 0,
            CompanyId: factory_data.CompanyId,
            BranchId: factory_data.BranchId,
          }}
          validate={(values) => {
            const errors = {};
            if (!values.factory_name || values.factory_name === "") {
              errors.factory_name = "กรุณากรอกชื่อโรงงาน";
            }
            if (!values.factory_address || values.factory_address === "") {
              errors.factory_address = "กรุณากรอกที่อยู่โรงงาน";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            setTimeout(() => {
              if (values.factory_name != factory_data.FactoryName) {
                const check_names = {
                  name: values.factory_name,
                };

                api
                  .post("api/check/name", check_names)
                  .then((res) => {
                    if (res.data.status) {
                      const data = {
                        id: factory_data.FactoryId,
                        name: values.factory_name,
                        address: values.factory_address,
                        phone: values.factory_phone,
                        fax: values.factory_fax,
                        FactoryCode: values.FactoryCode,
                        FactoryMAC5Code: values.FactoryMAC5Code,
                        status: values.status,
                        ModId: EmpId,
                        CompanyId: company || null,
                        BranchId: branch || null,
                      };

                      api
                        .post("api/factory/update", data)
                        .then((respose) => {
                          const MySwal = withReactContent(Swal);

                          MySwal.fire({
                            icon: "success",
                            didOpen: () => {
                              MySwal.clickConfirm();
                            },
                          }).then(() => {
                            return MySwal.fire(
                              "สำเร็จ!",
                              "แก้ไขโรงงานสำเร็จ !",
                              "success"
                            ).then((result) => {
                              if (result.isConfirmed) {
                                history.push("/CustomerSupport/Factory");
                              }
                            });
                          });
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }
                    if (!res.data.status) {
                      const MySwal = withReactContent(Swal);
                      MySwal.fire({
                        icon: "error",
                        didOpen: () => {
                          MySwal.clickConfirm();
                        },
                      }).then(() => {
                        return MySwal.fire(
                          "ไม่สำเร็จ!",
                          "พบชื่อโรงงานนี้ซ้ำในระบบ กรุณาตรวจสอบอีกครั้ง ! <hr/> ชื่อโรงงาน : " +
                            res.data?.data[0].name +
                            "<br/> ที่อยู่ : " +
                            res.data?.data[0].address +
                            "<br/> เบอร์โทรศัพท์ : " +
                            res.data?.data[0].phone +
                            "<br/> แฟกซ์ : " +
                            res.data?.data[0].fax +
                            "<hr/>",
                          "error"
                        );
                      });
                    }
                  })
                  .catch((err) => {
                    const MySwal = withReactContent(Swal);
                    MySwal.fire({
                      icon: "error",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "ไม่สำเร็จ!",
                        "ไม่สามารถเชื่อมต่อกับ Server ได้ !",
                        "error"
                      );
                    });
                  });
              }
              //
              if (values.factory_name == factory_data.FactoryName) {
                const data = {
                  id: factory_data.FactoryId,
                  name: values.factory_name,
                  address: values.factory_address,
                  phone: values.factory_phone,
                  fax: values.factory_fax,
                  FactoryCode: values.FactoryCode,
                  FactoryMAC5Code: values.FactoryMAC5Code,
                  status: values.status,
                  ModId: EmpId,
                  CompanyId: company || null,
                  BranchId: branch || null,
                };

                api
                  .post("api/factory/update", data)
                  .then((respose) => {
                    const MySwal = withReactContent(Swal);

                    MySwal.fire({
                      icon: "success",
                      didOpen: () => {
                        MySwal.clickConfirm();
                      },
                    }).then(() => {
                      return MySwal.fire(
                        "สำเร็จ!",
                        "แก้ไขโรงงานสำเร็จ !",
                        "success"
                      ).then((result) => {
                        if (result.isConfirmed) {
                          history.push("/CustomerSupport/Factory");
                        }
                      });
                    });
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }

              setSubmitting(false);
            }, 400);
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit} style={{ margin: "20px" }}>
              <Grid container>
                <Grid item xs={4} sm={4} md>
                  <TextField
                    name="factory_name"
                    label="ชื่อโรงงาน"
                    variant="outlined"
                    placeholder="ชื่อโรงงาน"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{ width: "50%" }}
                    InputLabelProps={{ shrink: true }}
                    value={values.factory_name}
                    classes={{
                      root: !values.factory_name ? classes.customOutline : null,
                    }}
                    required
                  />
                  <br />
                  <TextField
                    name="FactoryCode"
                    label="รหัสโรงงาน"
                    variant="outlined"
                    placeholder="รหัสโรงงาน"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={values.FactoryCode}
                    // classes={{ root: !values.factory_code ? classes.customOutline : null }}
                    // required
                  />
                  <br />

                  <TextField
                    name="FactoryMAC5Code"
                    label="MAC-5 Code "
                    variant="outlined"
                    placeholder="MAC-5 Code "
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    InputLabelProps={{ shrink: true }}
                    value={values.FactoryMAC5Code}
                    // classes={{ root: !values.factory_code ? classes.customOutline : null }}
                    // required
                  />

                  <br />
                  <TextField
                    label="ที่อยู่"
                    InputLabelProps={{ shrink: true }}
                    placeholder="ที่อยู่"
                    name="factory_address"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.factory_address}
                    classes={{
                      root: !values.factory_address
                        ? classes.customOutline
                        : null,
                    }}
                    required
                  />

                  <br />
                  <TextField
                    label="เบอร์โทรศัพท์"
                    InputLabelProps={{ shrink: true }}
                    placeholder="เบอร์โทรศัพท์"
                    name="factory_phone"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.factory_phone}
                  />

                  <br />
                  <TextField
                    label="แฟ็กซ์"
                    InputLabelProps={{ shrink: true }}
                    placeholder="แฟ็กซ์"
                    name="factory_fax"
                    style={{
                      width: "50%",
                      marginTop: "10px",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.factory_fax}
                  />
                  <br />

                  <FormControl sx={{ width: "50%", marginTop: "10px" }}>
                    <InputLabel>Company</InputLabel>
                    <Select
                      name="Company"
                      label="Company"
                      value={company || ''}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => {
                        setCompany(e.target.value);
                        setBranch("");
                        if (e.target.value) {
                          setBranchDataFilter(
                            branchData.filter(
                              (item) => item?.CompanyId === e.target.value
                            )
                          );
                        } else {
                          setBranchDataFilter(branchData);
                        }
                      }}
                    >
                      <MenuItem value={""}>None</MenuItem>
                      {companyData?.map((item) => {
                        return (
                          <MenuItem value={item?.CompanyId}>
                            {item?.CompanyName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <br />
                  <FormControl sx={{ width: "50%", marginTop: "10px" }}>
                    <InputLabel>Branch</InputLabel>
                    <Select
                      name="Branch"
                      label="Branch"
                      value={branch || ''}
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) => setBranch(e.target.value)}
                    >
                      <MenuItem value={""}>None</MenuItem>
                      {branchDataFilter?.map((item) => {
                        return (
                          <MenuItem value={item?.BranchId}>
                            {item?.BranchName}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                  <br />
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <FormControl
                      sx={{
                        width: "50%",
                        marginBottom: "10px",
                      }}
                    >
                      <InputLabel>สถานะ</InputLabel>
                      <Select
                        name="status"
                        label="สถานะ"
                        value={values.status}
                        InputLabelProps={{ shrink: true }}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      >
                        <MenuItem value="" disabled>
                          <em>เลือก สถานะ</em>
                        </MenuItem>
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>InActive</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </Grid>
              </Grid>
              <div style={{ marginTop: 10 }}>
                <Button
                  type="button"
                  variant="outlined"
                  style={{
                    color: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  onClick={history.goBack}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  style={{
                    background: "#80c340",
                    borderColor: "#80c340",
                    marginRight: "10px",
                  }}
                  disabled={isSubmitting}
                >
                  {isSubmitting && <CircularProgress size={22} />}
                  {!isSubmitting && "SAVE"}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Card>
    </div>
  );
}
